import {until} from 'lit-html/directives/until';
import '../roster-export-link';
import {pages, jobStatuses, permissions, dynamicPages} from '@modules/constants-enumerate';
import {hasOneOfPermissions} from '@modules/permissions';
import {nothing} from 'lit-html';

const downloadLimitIndex = 10;
let gotlastSuccessfulRoster = false;

export default (ctx, html) => {
  gotlastSuccessfulRoster = false;
  let rows;
  if (ctx.filteredRosters && ctx.filteredRosters?.length > 0) {
    rows = html`${ctx.filteredRosters.map((roster, index) => renderRow(ctx, html, roster, index))}`;
  }

  return html`
    <div class="row my-5">
      <div class="col-sm-12 col-lg-4">
        <h1 class="h2 m-0">${until(ctx.__('<tt-DRVaVa2s>', 'Roster Archives'))}</h1>
      </div>
      <div class="col-sm-12 col-lg-8 my-3 my-lg-0">
        <roster-export-link></roster-export-link>
      </div>
    </div>

    <div class="row">${rows}</div>
  `;
};

const renderRow = (ctx, html, roster, index) => {
  return html`
    <div class="col-12">
      <collapse-button
        role="button"
        controls="(ungrouped, roster-${roster.id})"
        class="list-group-item d-flex justify-content-between">
        <div class="flex-fill mr-3">
          <span class="mr-4">${roster.params_json.original_filename}</span>
          <span>${roster.$startTime}</span>
          <job-status-badge class="float-right" .status="${roster.status}"></job-status-badge>
        </div>
        <span class="ai ai-chevron-down"></span>
      </collapse-button>
      <ems-collapse group="ungrouped" id="roster-${roster.id}" ?open="${index === 0}">
        ${roster.status !== jobStatuses.FAILED ? renderSuccess(ctx, html, roster) : nothing}
        ${renderRosterActions(ctx, html, roster, index)}
      </ems-collapse>
    </div>
  `;
};

const renderSummary = (html, roster, section, href, label) => {
  if (!roster.summary[section]) {
    return;
  }

  return html`
    <div class="col-lg-3 col-md-4 col-xs-6">
      <roster-summary-block class="mb-5" .rosterSummary="${roster.summary[section]}">
        <link-to href="${href}" slot="label">${until(label)}</link-to>
      </roster-summary-block>
    </div>
  `;
};

const renderSuccess = (ctx, html, roster) => {
  const teachersLabel = ctx.__('<tt-wv3+DejF>', 'Teachers');
  return html`
    <div class="row justify-content-start justify-content-md-center pt-3">
      ${renderSummary(html, roster, 'students', pages.STUDENT_SEARCH, ctx.__('<tt-li6JgGIw>', 'Students'))}
      ${renderGroupSummaries(ctx, html, roster)}
      ${renderSummary(html, roster, 'classrooms', pages.CLASSES_SEARCH, ctx.__('<tt-/gxR/UDH>', 'Classes'))}
      ${renderSummary(html, roster, 'users', pages.TEACHER_SEARCH, teachersLabel)}
      ${renderSummary(html, roster, 'teachers', pages.TEACHER_SEARCH, teachersLabel)}
      ${renderSummary(html, roster, 'admins', pages.TEACHER_SEARCH, ctx.__('<tt-j1wRIEGr>', 'Administrators'))}
    </div>
  `;
};

const renderGroupSummaries = (ctx, html, roster) => html`
  ${Object.keys(roster.summary.groups).map((level) => {
    if (parseInt(level, 10) <= parseInt(ctx.groupInfo.level, 10)) {
      return '';
    }
    return html`
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
        <roster-summary-block class="mb-5" .rosterSummary="${roster.summary.groups[level]}">
        <link-to href="${dynamicPages.orgGroupSearch(level, ctx.groupInfo.path + ctx.groupInfo.id + '.')}" slot="label">
            ${ctx.myGroups[level].label}
        </link-to>
        </roster-summary-block>
      </div>
    `;
  })}
`;

const renderRosterActions = (ctx, html, roster, index) => html`
  <div class="row justify-content-center">
    ${index < downloadLimitIndex ? renderDownloadLink(ctx, html, roster) : ''}
    ${roster.status === jobStatuses.FAILED ? renderErrorsLink(ctx, html, roster) : ''}
    ${isLastSuccessfulRoster(roster) ? html`
    <div class="col-xs-6 col-sm-4 mb-5">
      <button @click=${ctx.openLicenseModal}
        role="button"
        class="btn btn-block btn-primary btn-lg rounded-pill ${!hasOneOfPermissions([permissions.LICENSE_APPLY]) ? 'disabled' : ''}"
        ?disabled="${!hasOneOfPermissions([permissions.LICENSE_APPLY])}"
      >
        ${until(ctx.__('<tt-Pl/e0rgS>', 'Assign Licenses Now'))}
      </button>
    </div>` : ''}
  </div>
`;


const isLastSuccessfulRoster = (roster) => {
  if (roster.status === jobStatuses.DONE && !gotlastSuccessfulRoster) {
    gotlastSuccessfulRoster = true;
    return true;
  }
  return false;
};



const renderDownloadLink = (ctx, html, roster) => {
  if (roster.params_json.data_type !== 'aofl' && roster.params_json.data_type !== 'oneroster') {
    return;
  }
  let downloadLink = '';
  if (ctx.disableDownloadLink[roster.id]) {
    downloadLink = html`
      <div class="spinner-border mr-3" role="status">
        <span class="sr-only">Downloading...</span>
      </div>
    `;
  } else {
    downloadLink = until(ctx.__('<tt-/MZdlzgG>', 'Download'));
  }
  return html`
    <div class="col-xs-6 col-sm-4 mb-5">
      <button
        role="button"
        class="btn btn-block btn-lg btn-link rounded-pill"
        @click="${() => ctx.download(roster.id)}"
        .disabled="${ctx.disableDownloadLink[roster.id]}"
      >
        ${downloadLink}
      </button>
    </div>
  `;
};

const renderErrorsLink = (ctx, html, roster) => {
  if (roster.params_json.data_type !== 'aofl' && roster.params_json.data_type !== 'oneroster') {
    return;
  }
  return html`
    <div class="col-xs-6 col-sm-4 mb-5">
      <button
        class="btn btn-block btn-lg btn-link rounded-pill"
        @click="${(e) => ctx.openErrorsModal(roster, e)}"
      >${until(ctx.__('<tt-ExF8daE/>', 'Show Errors'))}
      </button>
    </div>
  `;
};
